<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-gray-800 pt-10" v-if="dane.title">
    <form class="space-y-8 divide-y divide-gray-700">
      <div class="space-y-8 divide-y divide-gray-700">
        <div>
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-3">
              <h1 class="text-3xl font-semibold text-white">{{ dane.title }}</h1>
              <span
                v-if="isPremiumComputed"
                class="inline-flex items-center rounded-full bg-amber-400/20 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-300 ring-1 ring-amber-300/50"
              >
                PREMIUM
              </span>
            </div>
            <button
              @click="confirmDeleteLocal"
              type="button"
              class="rounded-md border border-red-500 text-red-500 py-2 px-4 text-sm font-medium bg-gray-800 hover:bg-red-500 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              Usuń lokal
            </button>
          </div>

          <div class="mt-1 flex rounded-md shadow-sm"></div>

          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-3/5 px-2 pt-2">
              <label for="title" class="block text-sm font-medium text-gray-500">title</label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.title"
                  name="title"
                  id="title"
                  autocomplete="off"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
          </div>

          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-2 pt-2">
              <label for="street" class="block text-sm font-medium text-gray-500"
                >street</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.street"
                  name="street"
                  id="street"
                  autocomplete="street"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2 pt-2">
              <label
                for="postcode"
                class="block text-sm font-medium text-gray-500"
                >postcode</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.postcode"
                  name="postcode"
                  id="postcode"
                  autocomplete="postcode"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2 pt-2">
              <label for="city" class="block text-sm font-medium text-gray-500"
                >city</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.city"
                  name="city"
                  id="city"
                  autocomplete="city"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
          </div>

          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-2 pt-2">
              <label
                for="lat"
                class="block text-sm font-medium text-gray-500"
                >position</label
              >
              <div class="mt-1">
                <div class="mt-1 relative">
                  <input
                    type="text"
                    name="position"
                    v-model="position"
                    id="position"
                    autocomplete="position"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700 pr-16"
                  />
                  <span
                    @click="position = placeDetails.position"
                    v-if="
                      placeDetails?.position &&
                      position !== placeDetails.position
                    "
                    class="bg-orange-500 hover:bg-orange-600 text-sm text-black px-2 py-1 cursor-pointer rounded-md absolute right-2 top-1/2 transform -translate-y-1/2"
                    >update</span
                  >
                </div>
              </div>
            </div>

            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2 pt-2">
              <label for="gid" class="block text-sm font-medium text-gray-500">
                <span class="flex items-center">
                  gid
                  <a
                    v-if="dane.gid"
                    :href="`https://www.google.com/maps/place/?q=place_id:${dane.gid}`"
                    target="_blank"
                    class="ml-1.5 text-gray-400 hover:text-indigo-400"
                    aria-label="Otwórz w Google Maps"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </span>
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.gid"
                  name="gid"
                  id="gid"
                  autocomplete="gid"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>

            <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-2 pt-2">
              <label for="cid" class="block text-sm font-medium text-gray-500"
                >cid</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.cid"
                  name="cid"
                  id="cid"
                  autocomplete="gid"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
          </div>

          <div class="w-full flex flex-wrap">
            <div class="mt-6 sm:mt-0 sm:w-3/5">
              <label
                for="type"
                class="block text-sm font-medium text-gray-200 mt-2"
                >tagi</label
              >
              <div class="mt-1 relative">
                <!-- Widoczne tagi -->
                <div
                  class="flex flex-wrap gap-2 mb-2 min-h-[32px] p-2 bg-gray-700 border border-gray-600 rounded-md"
                >
                  <div
                    v-for="(tag, index) in selectedTags"
                    :key="index"
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                  >
                    {{ tag }}
                    <button
                      type="button"
                      @click.prevent="removeTag(index)"
                      class="ml-1 text-green-600 hover:text-green-800 font-bold bg-green-100"
                    >
                      ×
                    </button>
                  </div>
                </div>

                <!-- Input do dodawania tagów + szybkie tagi -->
                <div
                  class="flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-4"
                >
                  <div
                    class="relative w-full sm:flex-1 sm:max-w-xs"
                  >
                    <input
                      type="text"
                      v-model="tagInput"
                      name="tagInput"
                      id="tagInput"
                      autocomplete="off"
                      @input="filterTags"
                      @focus="handleTagInputFocus"
                      @blur="hideTagSuggestions"
                      @paste="handleTagPaste"
                      @keydown.down.prevent="moveTagSelectionDown"
                      @keydown.up.prevent="moveTagSelectionUp"
                      @keydown.enter.prevent="handleTagEnter"
                      @keydown.tab.prevent="addTagFromInput"
                      placeholder="Wpisz nazwę tagu i naciśnij Enter..."
                      class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                    />

                    <!-- Tag suggestions dropdown -->
                    <div
                      v-if="showTagSuggestions && filteredTags.length > 0"
                      class="absolute z-10 w-full mt-1 bg-gray-700 border border-gray-600 rounded-md shadow-lg max-h-60 overflow-auto"
                    >
                      <div
                        v-for="(tag, index) in filteredTags"
                        :key="tag.id"
                        @click="selectTag(tag.name)"
                        @mouseenter="highlightedTagIndex = index"
                        :class="[
                          'px-4 py-2 cursor-pointer text-white text-sm',
                          highlightedTagIndex === index
                            ? 'bg-gray-600'
                            : 'hover:bg-gray-600',
                        ]"
                      >
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mr-2"
                        >
                          {{ tag.name }}
                        </span>
                        <span
                          v-if="tag.category"
                          class="text-gray-400 text-xs"
                          >{{ tag.category }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-wrap gap-2">
                    <button
                      v-for="quickTag in quickTags"
                      :key="quickTag"
                      type="button"
                      @click="selectTag(quickTag)"
                      class="px-3 py-1 text-xs font-medium rounded-md border border-indigo-600 text-indigo-200 hover:bg-indigo-600 hover:text-white transition-colors"
                    >
                      {{ quickTag }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6 sm:mt-0 sm:w-1/5">
              <div class="mt-6 sm:mt-0 w-full px-3">
                <label for="author" class="block text-sm font-medium text-gray-200 mt-2">author</label>
                <div class="mt-1">
                  <select v-model="dane.author" name="author" id="author" autocomplete="author"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700">
                    <option disabled value="">Wybierz autora</option>
                    <option v-for="influencer in influencers" :key="influencer.id" :value="influencer.name">{{ influencer.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mt-6 sm:mt-0 sm:w-1/5">
              <div class="mt-6 sm:mt-0 w-full px-3">
                <label
                  for="status"
                  class="block text-sm font-medium text-gray-200 mt-2"
                  >status</label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="dane.status"
                    name="status"
                    id="status"
                    autocomplete="status"
                    :class="[
                      'block w-full rounded-md shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white',
                      dane.status === 'closed'
                        ? 'border-red-500 bg-red-500 font-bold'
                        : 'border-gray-600 bg-gray-700',
                    ]"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="w-full flex flex-wrap">
            <div class="mt-6 sm:mt-0 sm:w-3/5">
              <label
                for="type"
                class="block text-sm font-medium text-gray-200 mt-2"
                >pyszne.pl url</label
              >
              <div class="mt-1">
                <input
                  type="text"
                  v-model="dane.url_pyszne"
                  name="type"
                  id="type"
                  autocomplete="type"
                  class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                />
              </div>
            </div>
            <div class="mt-6 sm:mt-0 sm:w-1/5">
              <div class="mt-6 sm:mt-0 w-full px-3">
                <label
                  for="status"
                  class="block text-sm font-medium text-gray-200 mt-2"
                  >&nbsp;</label
                >
                <div class="mt-1">
                  <button
                    v-if="!dane.url_pyszne"
                    @click="openGoogle(dane)"
                    type="button"
                    class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2 block w-full"
                  >
                    google it
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap -mx-3">
            <div class="mt-6 sm:mt-0 w-full px-2 pt-2">
              <label class="block text-sm font-medium text-gray-200 mt-2">
                Zdjęcia lokalu
              </label>
              <div class="mt-1 rounded-md border border-gray-600 bg-gray-700/40 p-4">
                <div class="flex flex-wrap items-center justify-between gap-3">
                  <p class="text-xs text-gray-400">
                    Przeciągnij miniaturki, aby ustawić kolejność zdjęć.
                  </p>
                  <div class="flex items-center gap-2">
                    <input
                      id="place-photo-input"
                      class="hidden"
                      type="file"
                      accept="image/*"
                      multiple
                      @change="onPlacePhotoPick"
                    />
                    <button
                      type="button"
                      @click="triggerPlacePhotoInput"
                      :disabled="isUploadingPlacePhoto || !dane.id"
                      class="rounded-md border border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      {{ isUploadingPlacePhoto ? "Upload..." : "Dodaj zdjęcia" }}
                    </button>
                  </div>
                </div>

                <div
                  v-if="placePhotos.length"
                  class="mt-4 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-2"
                >
                  <div
                    v-for="(photoUrl, photoIndex) in placePhotos"
                    :key="`${photoUrl}-${photoIndex}`"
                    :draggable="!isSavingPlacePhotosOrder"
                    @dragstart="onPlacePhotoDragStart(photoIndex, $event)"
                    @dragover.prevent="onPlacePhotoDragOver(photoIndex, $event)"
                    @drop.prevent="onPlacePhotoDrop(photoIndex, $event)"
                    @dragend="onPlacePhotoDragEnd"
                    class="rounded-md border bg-gray-800 p-2 transition cursor-grab active:cursor-grabbing"
                    :class="[
                      dragOverPlacePhotoIndex === photoIndex
                        ? 'border-indigo-400 ring-1 ring-indigo-400'
                        : 'border-gray-600',
                      isSavingPlacePhotosOrder ? 'cursor-not-allowed opacity-80' : '',
                    ]"
                  >
                    <img
                      :src="toAbsoluteUploadUrl(photoUrl)"
                      alt="Zdjęcie lokalu"
                      class="aspect-square w-full rounded-md bg-gray-900 p-1 object-contain"
                    />
                    <button
                      type="button"
                      @click="removePlacePhoto(photoUrl)"
                      :disabled="removingPlacePhotoUrl === photoUrl || isSavingPlacePhotosOrder"
                      class="mt-2 w-full rounded-md border border-red-500 bg-transparent py-1.5 px-2 text-xs font-medium text-red-400 hover:bg-red-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      {{
                        removingPlacePhotoUrl === photoUrl
                          ? "Usuwanie..."
                          : "Usuń zdjęcie"
                      }}
                    </button>
                  </div>
                </div>
                <p v-if="isSavingPlacePhotosOrder" class="mt-3 text-xs text-indigo-300">
                  Zapisywanie kolejności zdjęć...
                </p>
                <p v-else-if="!placePhotos.length" class="mt-3 text-sm text-gray-400">
                  Brak dodanych zdjęć dla tego lokalu.
                </p>
              </div>
            </div>
          </div>

          <div v-if="dane.ratingValue" class="mt-6 flex">
            <div class="mt-1">
              <p
                class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-black bg-yellow-600"
              >
                ★ {{ dane.ratingValue }}
              </p>
            </div>

            <div class="mt-1">
              <p
                class="px-3 py-3 rounded-md border-yellow-600 font-bold sm:text-sm text-yellow-600"
              >
                {{ dane.reviewCount }}
              </p>
            </div>
          </div>

          <fieldset class="space-x-5 flex flex-wrap items-start py-5">
            <div class="relative flex">
              <div class="flex h-5 items-center">
                <label
                  class="flex items-center cursor-pointer select-none"
                >
                  <span class="relative">
                    <input
                      id="isMuala"
                      aria-describedby="isMuala-description"
                      name="isMuala"
                      v-model="isMualaComputed"
                      type="checkbox"
                      class="sr-only peer"
                    />
                    <span
                      class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"
                    ></span>
                    <span
                      class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"
                    ></span>
                  </span>
                  <span
                    class="ml-3 text-sm font-medium text-gray-200"
                    >{{ isMualaComputed ? "YES" : "NO" }}</span
                  >
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label
                  for="isMuala"
                  class="font-medium text-gray-200"
                  >isMuala</label
                >
                <span
                  id="isMuala-description"
                  class="text-gray-500"
                  ><span class="sr-only"
                    >isMuala
                  </span></span
                >
              </div>
            </div>

            <div class="relative flex">
              <div class="flex h-5 items-center">
                <label
                  class="flex items-center cursor-pointer select-none"
                >
                  <span class="relative">
                    <input
                      id="isGroup"
                      aria-describedby="isGroup-description"
                      name="isGroup"
                      v-model="isGroupComputed"
                      type="checkbox"
                      class="sr-only peer"
                    />
                    <span
                      class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"
                    ></span>
                    <span
                      class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"
                    ></span>
                  </span>
                  <span
                    class="ml-3 text-sm font-medium text-gray-200"
                    >{{ isGroupComputed ? "YES" : "NO" }}</span
                  >
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label
                  for="isGroup"
                  class="font-medium text-gray-200"
                  >isGroup</label
                >
                <span
                  id="isGroup-description"
                  class="text-gray-500"
                  ><span class="sr-only"
                    >isGroup
                  </span></span
                >
              </div>
            </div>

            <div class="relative flex">
              <div class="flex h-5 items-center">
                <label
                  class="flex items-center cursor-pointer select-none"
                >
                  <span class="relative">
                    <input
                      id="isPremium"
                      aria-describedby="isPremium-description"
                      name="isPremium"
                      v-model="isPremiumComputed"
                      type="checkbox"
                      class="sr-only peer"
                    />
                    <span
                      class="w-11 h-6 bg-gray-400 rounded-full shadow-inner block peer-checked:bg-blue-600 transition-colors"
                    ></span>
                    <span
                      class="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform peer-checked:translate-x-5"
                    ></span>
                  </span>
                  <span
                    class="ml-3 text-sm font-medium text-gray-200"
                    >{{ isPremiumComputed ? "YES" : "NO" }}</span
                  >
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label
                  for="isPremium"
                  class="font-medium text-gray-200"
                  >isPremium</label
                >
                <span
                  id="isPremium-description"
                  class="text-gray-500"
                  ><span class="sr-only"
                    >isPremium
                  </span></span
                >
              </div>
            </div>
          </fieldset>

          <!-- OPIS -->
          <div
            v-for="dane in reviews"
            class="bg-gray-700 p-5 rounded-md mb-5"
          >
            <div class="flex items-end gap-4">
              <div class="w-full sm:w-3/5">
                <label
                  for="shortdesc"
                  class="block text-sm font-medium text-gray-200"
                  >shortDesc</label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="dane.shortdesc"
                    name="shortdesc"
                    id="shortdesc"
                    autocomplete="shortdesc"
                    @input="sanitizeShortDesc(dane)"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  />
                </div>
              </div>
              <div class="w-full sm:w-2/5">
                <div class="mt-7">
                  <button
                    @click.prevent="pasteReview(dane)"
                    :class="[
                      'ml-3 inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2',
                      isError
                        ? 'bg-red-600 hover:bg-red-700'
                        : 'bg-indigo-700 hover:bg-indigo-800',
                    ]"
                  >
                    paste JSON review
                  </button>
                </div>
              </div>
            </div>

            <label
              for="opis"
              class="block text-sm font-medium text-gray-200 mt-2"
              >opis</label
            >
            <div class="mt-1">
              <textarea
                id="opis"
                v-model="dane.text"
                name="opis"
                rows="3"
                class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
              />
            </div>

            <div class="flex flex-wrap -mx-3 mt-2">
              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
                <label
                  for="author"
                  class="block text-sm font-medium text-gray-200"
                  >author</label
                >
                <div class="mt-1">
                  <select
                    v-model="dane.author"
                    name="author"
                    id="author"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  >
                    <option value="">Wybierz influencera</option>
                    <option
                      v-for="influencer in influencers"
                      :key="influencer.id"
                      :value="influencer.name"
                    >
                      {{ influencer.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
                <label
                  for="videoid"
                  class="block text-sm font-medium text-gray-200"
                  ><a
                    :href="`https://www.youtube.com/watch?v=${dane.videoid}`"
                    target="_bank"
                    >videoid (play)</a
                  ></label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="dane.videoid"
                    name="videoid"
                    id="videoid"
                    autocomplete="videoid"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  />
                </div>
              </div>
              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
                <label
                  for="timestamp"
                  class="block text-sm font-medium text-gray-200"
                  >timestamp</label
                >
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="dane.timestamp"
                    name="timestamp"
                    id="timestamp"
                    autocomplete="timestamp"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                  />
                </div>
              </div>

              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3">
                <label
                  for="publishedat"
                  class="block text-sm font-medium text-gray-200"
                  >publishedat</label
                >

                <div class="mt-1">
                  <input
                    type="date"
                    v-model="dane.publishedat"
                    name="publishedat"
                    id="publishedat"
                    :max="getTodayDate()"
                    class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
                    required
                  />
                </div>
              </div>
              <div class="mt-6 sm:mt-0 w-full sm:w-1/5 px-3 flex items-end">
                <button
                  @click.prevent="deleteReview(dane.id)"
                  type="button"
                  class="text-red-500 hover:text-red-400 p-2 rounded-full hover:bg-gray-600 transition-colors"
                  aria-label="Usuń recenzję"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="text-center mt-2 mb-2">
            <span
              @click="addNewReview(dane.id)"
              class="material-icons-round mr-5 hover:cursor-pointer hover:text-green-500 text-gray-200"
            >
              add_circle
            </span>
          </div>

          <!-- JSON ARTICLE -->
          <div>
            <label
              for="opis"
              class="block text-sm font-medium text-gray-200 mt-5"
              >Article (landing JSON)</label
            >
            <div class="mt-1">
              <textarea
                id="opis"
                v-model="article.json"
                name="opis"
                rows="3"
                class="block w-full rounded-md border-gray-600 shadow-sm focus:border-indigo-700 focus:ring-indigo-700 sm:text-sm text-white bg-gray-700"
              />
            </div>
            <router-link
              :to="`/preview/${currentTagId}`"
              target="_blank"
              class="text-white underline mt-2 block"
              >preview article</router-link
            >
            <router-link
              :to="`/og-preview/${currentTagId}`"
              target="_blank"
              class="text-white underline mt-1 block"
              >open OG preview</router-link
            >
            <div class="mt-4">
              <div class="mb-3 flex items-center justify-between">
                <div class="inline-flex rounded-md border border-gray-600 overflow-hidden">
                  <button
                    type="button"
                    @click="ogPreviewTab = 'inline'"
                    :class="[
                      'px-3 py-1.5 text-xs font-medium',
                      ogPreviewTab === 'inline'
                        ? 'bg-indigo-700 text-white'
                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700',
                    ]"
                  >
                    Open Graph preview (inline)
                  </button>
                  <button
                    type="button"
                    @click="ogPreviewTab = 'png'"
                    :class="[
                      'px-3 py-1.5 text-xs font-medium border-l border-gray-600',
                      ogPreviewTab === 'png'
                        ? 'bg-indigo-700 text-white'
                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700',
                    ]"
                  >
                    Generated OG PNG
                  </button>
                </div>
                <button @click="refreshOG" type="button" class="rounded-md border border-gray-600 bg-gray-700 py-1 px-3 text-xs font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2">Refresh</button>
              </div>
              <div v-if="ogPreviewTab === 'inline'" class="rounded-md overflow-hidden border border-gray-700">
                <iframe
                  :key="ogIframeKey"
                  :src="`/og-preview/${currentTagId}`"
                  class="w-full"
                  style="height: 660px; background: #111;"
                ></iframe>
              </div>
              <div v-else class="mt-2">
                <div class="flex items-center gap-2">
                  <button @click="deleteOG" type="button" class="rounded-md border border-gray-600 bg-gray-700 py-1 px-3 text-xs font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2">Usuń OG</button>
                  <button @click="rebuildOG" type="button" class="rounded-md border border-gray-600 bg-gray-700 py-1 px-3 text-xs font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2">Przebuduj OG</button>
                </div>
                <div class="mt-2 rounded-md overflow-auto border border-gray-700 bg-gray-900" style="max-width: 100%">
                  <img :src="ogPngUrl" alt="OG PNG preview" style="width: 1200px; height: 630px; display: block;" :class="{ 'opacity-10 animate-pulse': isRebuildingOG }" />
                </div>
                <a :href="ogPngUrl" target="_blank" class="text-white underline mt-2 inline-block">open PNG in new tab</a>
              </div>
            </div>
          </div>

          <div class="mt-6 sm:col-span-1">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div id="googleBox">
                <div class="whiteGoogle">
                  <div class="googleTop">
                    <div class="favicon">
                      <img
                        class="XNo5Ab"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEX6eAD8u4D////+5s/91K/7qmD7iCD93b//9+/+7t/7olD8s3D7mkD9zKD8xJD6gBD7kTBN0RVDAAAAyUlEQVR4AbWPBXbAMAzFftQ2DLv/afc8Bmc8FZPIpO8TOM5LDjHlUiVlgOgIBch74fnAROSQANqDUB3hAEgPQtiVQBGjO8KJoYYR90LaZkgYGhhtn6Gya3Jg9IuRfWFilEwYvhBgZoAwtz2sBFADXP4UKwNZG6HABZB0+sIJMwGHkt9Dg6BpAjAdYVniDqeKvRwscbOXpfGFUzaAvbJfIqtmmkaZwREqFHsHlSSPCV26oclEh34QrZJUWPIYJhhtyiWZ8BHnqX/hFtGBBaVJnDWFAAAAAElFTkSuQmCC"
                        style="height: 18px; width: 18px"
                      />
                    </div>

                    <div class="smallText">
                      <span id="googleUrl">muala.app</span>
                      <div class="googleBreadcrumbsContainer">
                        <span id="googleBreakcrumbs"
                          >https://muala.app › {{ dane.city }} ›
                          {{
                            dane.title.split(" ").join("-")
                          }}</span
                        >
                        <span class="dots"
                          ><svg
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                            ></path></svg
                        ></span>
                      </div>
                    </div>
                  </div>

                  <div class="relative">
                    <button
                      @click.prevent="
                        metaDane.metaTitle = titleCase(
                          metaDane.metaTitle,
                          exceptions
                        )
                      "
                      class="absolute top-0 right-0 mt-2 text-sm text-gray-500 hover:text-indigo-700 cursor-pointer z-10 bg-gray-800 hover:bg-gray-600 px-3 py-1 rounded-full"
                    >
                      TTC
                    </button>
                    <input
                      name="googleTitle"
                      id="googleTitle2"
                      v-model="metaDane.metaTitle"
                      class="rounded-md border-gray-700 text-white bg-gray-800 hover:border-gray-700 shadow-sm focus:border-indigo-700 focus:ring-indigo-700"
                    />
                  </div>

                  <textarea
                    name="googleDescription"
                    id="googleDescription2"
                    v-model="metaDane.metaDescription"
                    class="rounded-md border-gray-700 text-white bg-gray-800 hover:border-gray-500 shadow-sm focus:border-indigo-700 focus:ring-indigo-700"
                  ></textarea>

                  <div class="flex justify-between -mt-2">
                    <p
                      v-if="metaDane.metaDescription !== null"
                      :class="{
                        'text-red-500':
                          countCharactersWithEmojis(
                            metaDane.metaDescription
                          ) > 150,
                        'text-gray-500':
                          countCharactersWithEmojis(
                            metaDane.metaDescription
                          ) <= 150,
                      }"
                      class="mt-2 text-sm"
                    >
                      {{
                        countCharactersWithEmojis(metaDane.metaDescription)
                      }}
                    </p>
                    <a
                      class="mt-2 text-sm text-gray-500 hover:text-indigo-700 cursor-pointer"
                      @click="generateMetaDesc()"
                    >
                      {{ generatingMetaDesc ? "generating..." : "generate" }}</a
                    >
                  </div>
                  <div>
                    <a
                      @click="copyToClipboard('🍟')"
                      class="cursor-pointer hover:text-blue-500 hover:bg-gray-100 p-1 rounded"
                      >🍟</a
                    >
                    <a
                      @click="copyToClipboard('✔️')"
                      class="cursor-pointer hover:text-blue-500 hover:bg-gray-100 p-1 rounded"
                      >✔️</a
                    >
                    <a
                      @click="copyToClipboard('❤️')"
                      class="cursor-pointer hover:text-blue-500 hover:bg-gray-100 p-1 rounded"
                      >❤️</a
                    >
                    <a
                      @click="copyToClipboard('🌮🍕🥪🍔🥵🌶️🔥🌭')"
                      class="cursor-pointer hover:text-blue-500 hover:bg-gray-100 p-1 rounded"
                      >🌮🍕🥪🍔 🥵 🌶️ 🔥🌭</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-5"></div>
    </form>

    <div class="z-50 fixed bottom-0 left-0 w-full p-5 bg-gray-800">
      <div class="flex justify-end items-center">
        <button
          v-if="placeDetailsFull && placeDetailsFull.url"
          @click="openUrl(placeDetailsFull.url)"
          type="button"
          class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2"
        >
          ► see on maps
        </button>

        <button
          @click="analyzeYesMaybe()"
          type="button"
          :disabled="isAnalyzingYesMaybe || !dane.gid"
          :class="[
            'rounded-md border mr-3 py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed',
            isAnalyzingYesMaybe
              ? 'animate-pulse opacity-90 border-red-500 bg-red-600 hover:bg-red-500 focus:ring-red-500'
              : 'border-gray-600 bg-gray-700 hover:bg-gray-600 focus:ring-indigo-700 disabled:opacity-50',
          ]"
        >
          {{
            isAnalyzingYesMaybe
              ? "YesMaybe processing"
              : "Yesmaybe (serpAPI)"
          }}
        </button>
        <button
          @click="putSearchToMaps()"
          type="button"
          class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2"
        >
          Map Search
        </button>

        <button
          v-if="dane.gid"
          @click="getPlaceDetails(dane.gid)"
          type="button"
          class="rounded-md border mr-3 border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2"
        >
          get details
        </button>

        <iconOnly
          :tagsIds="tagsIds"
          @updateNextTag="showNextTag"
          class="mr-3"
        />

        <div class="flex justify-end">
          <button
            @click="goBack"
            type="button"
            class="rounded-md border border-gray-600 bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-offset-2"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="saveAll(dane.gid)"
            class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="yesMaybeError || yesMaybeData"
      class="mt-4 rounded-md border border-gray-600 bg-gray-900 p-4"
    >
      <p
        v-if="yesMaybeError"
        class="mb-3 text-sm text-red-400"
      >
        {{ yesMaybeError }}
      </p>
      <div v-if="externalData" class="mt-4 rounded-xl bg-white p-4 text-gray-900">
        <div
          class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 max-w-2xl mx-auto items-center"
        >
          <div class="p-4 text-center">
            <div class="text-7xl font-bold text-blue-600">{{ fetchedAverageRating }}</div>
            <div class="flex justify-center text-yellow-400 mb-2">
              <span class="text-2xl" v-for="n in 5" :key="n">
                {{ n <= Math.round(fetchedAverageRatingNumber) ? "★" : "☆" }}
              </span>
            </div>
            <div class="text-sm text-gray-400">
              średnia z ostatnich {{ fetchedReviewsCount }}&nbsp;ocen
            </div>
          </div>

          <div class="text-center">
            <div class="flex items-center justify-center gap-2">
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8"
              >
                <circle cx="9.41479" cy="9.85059" r="9.23901" :fill="ratingTrend.iconColor" />
                <path :d="ratingTrend.iconPath" fill="#F9FAFB" />
              </svg>
              <div class="text-2xl font-bold" :class="ratingTrend.class">{{ ratingTrend.value }}</div>
            </div>
          </div>

          <div class="text-center p-4">
            <div class="flex items-center justify-center gap-2">
              <img src="data:image/svg+xml,%3csvg%20width='19'%20height='19'%20viewBox='0%200%2019%2019'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.2628%207.94956H16.6252V7.91671H9.50016V11.0834H13.9743C13.3215%2012.9268%2011.5676%2014.25%209.50016%2014.25C6.87698%2014.25%204.75016%2012.1232%204.75016%209.50004C4.75016%206.87685%206.87698%204.75004%209.50016%204.75004C10.711%204.75004%2011.8126%205.20683%2012.6514%205.95298L14.8906%203.71375C13.4767%202.39602%2011.5854%201.58337%209.50016%201.58337C5.12818%201.58337%201.5835%205.12806%201.5835%209.50004C1.5835%2013.872%205.12818%2017.4167%209.50016%2017.4167C13.8721%2017.4167%2017.4168%2013.872%2017.4168%209.50004C17.4168%208.96923%2017.3622%208.45108%2017.2628%207.94956Z'%20fill='%23FFC107'/%3e%3cpath%20d='M2.49609%205.81523L5.09711%207.72275C5.80091%205.98029%207.50536%204.75004%209.49997%204.75004C10.7108%204.75004%2011.8124%205.20683%2012.6512%205.95298L14.8904%203.71375C13.4765%202.39602%2011.5852%201.58337%209.49997%201.58337C6.45918%201.58337%203.82214%203.3001%202.49609%205.81523Z'%20fill='%23FF3D00'/%3e%3cpath%20d='M9.49996%2017.4167C11.5448%2017.4167%2013.4029%2016.6341%2014.8077%2015.3615L12.3575%2013.2882C11.5361%2013.9132%2010.5321%2014.2511%209.49996%2014.25C7.44084%2014.25%205.69244%2012.937%205.03377%2011.1047L2.45215%2013.0938C3.76236%2015.6576%206.42315%2017.4167%209.49996%2017.4167Z'%20fill='%234CAF50'/%3e%3cpath%20d='M17.2627%207.94948H16.625V7.91663H9.5V11.0833H13.9741C13.6619%2011.9606%2013.0995%2012.7273%2012.3563%2013.2885L12.3575%2013.2877L14.8077%2015.3611C14.6344%2015.5186%2017.4167%2013.4583%2017.4167%209.49996C17.4167%208.96915%2017.362%208.451%2017.2627%207.94948Z'%20fill='%231976D2'/%3e%3c/svg%3e" alt="Google" class="h-7 w-7">
              <div class="text-3xl font-bold text-gray-700">{{ googleRating }}</div>
            </div>
            <div class="text-sm text-gray-400">
              średnia ze wszystkich {{ googleReviewsCount }}&nbsp;ocen
            </div>
          </div>
        </div>

        <div v-if="analysisSummary" class="rounded-2xl p-2">
          <h2
            id="podsumowanie"
            class="text-xl font-semibold text-gray-900 mb-4 mt-6 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-blue-500 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
            Podsumowanie
          </h2>
          <p class="text-gray-700 leading-relaxed px-4 md:px-16 max-w-4xl mx-auto">
            {{ analysisSummary }}
          </p>
        </div>

        <div class="grid md:grid-cols-2 gap-6 mt-8 max-w-4xl mx-auto px-4">
          <div v-if="prosList.length" class="bg-emerald-50 border-green-200 border-2 rounded-xl p-6">
            <h2 id="plusy" class="text-xl font-semibold text-emerald-900 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-emerald-500 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              Plusy
            </h2>
            <div class="space-y-4">
              <div v-for="pro in prosList" :key="`pro-${pro.name}`" class="bg-white/50 rounded-lg p-4">
                <div class="flex justify-between items-start mb-2">
                  <h3 class="font-semibold text-emerald-900">{{ pro.name }}</h3>
                  <span class="bg-emerald-200 text-emerald-800 text-sm font-medium px-2.5 py-0.5 rounded-full">{{ pro.mentions }}×</span>
                </div>
                <p class="text-emerald-800 text-sm">{{ pro.description }}</p>
              </div>
            </div>
          </div>
          <div v-if="consList.length" class="bg-red-50 border-red-200 border-2 rounded-xl p-6">
            <h2 class="text-xl font-semibold text-red-900 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-red-500 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              Minusy
            </h2>
            <div class="space-y-4">
              <div v-for="con in consList" :key="`con-${con.name}`" class="bg-white/50 rounded-lg p-4">
                <div class="flex justify-between items-start mb-2">
                  <h3 class="font-semibold text-red-900">{{ con.name }}</h3>
                  <span class="bg-red-200 text-red-800 text-sm font-medium px-2.5 py-0.5 rounded-full">{{ con.mentions }}×</span>
                </div>
                <p class="text-red-800 text-sm">{{ con.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="recommendationsList.length" class="mt-8 max-w-4xl mx-auto px-4">
          <div class="bg-blue-50 border-blue-200 border-2 rounded-xl p-6">
            <h2 id="rekomendacje" class="text-xl font-semibold text-blue-900 mb-4 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-blue-500 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                />
              </svg>
              Rekomendacje
            </h2>
            <div class="space-y-4">
              <div
                v-for="rec in recommendationsList"
                :key="`rec-${rec.name}`"
                class="bg-white/50 rounded-lg p-4"
              >
                <div class="flex justify-between items-start mb-2">
                  <h3 class="font-semibold text-blue-900">{{ rec.name }}</h3>
                  <span class="bg-blue-200 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded-full">{{ rec.mentions }}×</span>
                </div>
                <p class="text-blue-800 text-sm">{{ rec.description }}</p>
              </div>
            </div>
          </div>
        </div>

        <details class="mt-6 rounded border border-gray-200 bg-gray-50 p-3">
          <summary class="cursor-pointer text-sm text-gray-700 hover:text-gray-900">
            Show raw JSON
          </summary>
          <pre class="mt-3 max-h-80 overflow-auto rounded bg-white p-3 text-xs text-gray-800">{{
            JSON.stringify(externalData, null, 2)
          }}</pre>
        </details>
      </div>
    </div>
  </div>

  <div class="flex flex-wrap -mx-3">
    <div class="mt-6 sm:mt-0 w-full sm:w-2/5 px-3">
      <div style="display: none">
        <input
          id="pac-input"
          class="controls"
          type="text"
          placeholder="Enter a location"
        />
      </div>
    </div>
  </div>

  <div class="px-4 sm:px-6 lg:px-8 mt-4">
    <div class="rounded-xl overflow-hidden border border-gray-700">
      <div ref="mapElement" class="map" id="map"></div>
    </div>
  </div>
  <div id="infowindow-content">
    <span id="place-name" class="title"></span><br />
    <span id="place-id"></span><br />
    <span id="place-address"></span>

    <br />
    <span id="place-lat"></span>, <span id="place-lng"></span>
  </div>

  <placeDetailsComponent
    :placeDetailsFull="placeDetailsFull"
  ></placeDetailsComponent>
</template>

<script setup>
import {
  ref,
  onMounted,
  watch,
  computed,
} from "vue";

import { useRoute, useRouter } from "vue-router";
import iconOnly from "../components/iconOnly.vue";
import placeDetailsComponent from "../components/placeDetails.vue";
import { apiUrl } from "../composables/apiBase";
import { apiFetch } from "../composables/apiClient";
import { auth } from "../firebase/config";

const isError = ref(false);

const props = defineProps({
  id: String,
});

const placeDetails = ref(null);
const placeDetailsFull = ref(null);
const reviews = ref(null);
const yesMaybeData = ref(null);
const yesMaybeError = ref("");
const isAnalyzingYesMaybe = ref(false);
const isAutoLoadingYesMaybe = ref(false);
const externalData = computed(() => yesMaybeData.value);
const analysisData = computed(() =>
  externalData.value?.analysis && typeof externalData.value.analysis === "object"
    ? externalData.value.analysis
    : externalData.value || {}
);
const placeInfoData = computed(() =>
  externalData.value?.placeInfo && typeof externalData.value.placeInfo === "object"
    ? externalData.value.placeInfo
    : {}
);

const hasValue = (value) => value !== null && value !== undefined && value !== "";

const getYesMaybeRatingValue = (data) =>
  data?.analysis?.google_rating ?? data?.google_rating ?? data?.placeInfo?.rating;

const getYesMaybeReviewCount = (data) =>
  data?.analysis?.total_reviews ??
  data?.google_review_count ??
  data?.placeInfo?.reviewCount;

const syncRatingFromYesMaybe = (data) => {
  const ratingValue = getYesMaybeRatingValue(data);
  const reviewCount = getYesMaybeReviewCount(data);

  if (hasValue(ratingValue)) {
    dane.value.ratingValue = ratingValue;
  }
  if (hasValue(reviewCount)) {
    dane.value.reviewCount = reviewCount;
  }
};

const toSafeNumber = (value, fallback = 0) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const fetchedAverageRatingNumber = computed(() =>
  toSafeNumber(
    analysisData.value?.average_fetched_rating ??
      externalData.value?.fetched_reviews_average_rating,
    0
  )
);

const googleRatingNumber = computed(() =>
  toSafeNumber(
    analysisData.value?.google_rating ??
      externalData.value?.google_rating ??
      placeInfoData.value?.rating,
    0
  )
);

const fetchedReviewsCount = computed(
  () =>
    analysisData.value?.fetched_reviews ??
    externalData.value?.fetched_reviews_count ??
    0
);

const googleReviewsCount = computed(
  () =>
    analysisData.value?.total_reviews ??
    externalData.value?.google_review_count ??
    placeInfoData.value?.reviewCount ??
    0
);

const analysisSummary = computed(
  () =>
    analysisData.value?.general_summary ??
    externalData.value?.analysis_summary ??
    ""
);

const fetchedAverageRating = computed(() =>
  fetchedAverageRatingNumber.value.toFixed(1)
);

const googleRating = computed(() => googleRatingNumber.value.toFixed(1));

const ratingTrend = computed(() => {
  const diff = fetchedAverageRatingNumber.value - googleRatingNumber.value;

  if (diff >= 0.2) {
    return {
      value: `+${diff.toFixed(1)}`,
      class: "text-emerald-600",
      iconColor: "#10B981",
      iconPath: "M9.5 4L14 9H11V16H8V9H5L9.5 4Z",
    };
  }

  if (diff <= -0.2) {
    return {
      value: diff.toFixed(1),
      class: "text-red-600",
      iconColor: "#EF4444",
      iconPath: "M9.5 16L5 11H8V4H11V11H14L9.5 16Z",
    };
  }

  return {
    value: "0.0",
    class: "text-gray-600",
    iconColor: "#6B7280",
    iconPath: "M4 9H15V11H4V9Z",
  };
});

const normalizeListItems = (items) => {
  if (!Array.isArray(items)) return [];

  return items.map((item, index) => ({
    name: item?.name || item?.title || `Pozycja ${index + 1}`,
    mentions: item?.mentions ?? item?.count ?? 0,
    description: item?.description || item?.summary || "",
  }));
};

const prosList = computed(() =>
  normalizeListItems(analysisData.value?.pros ?? externalData.value?.pros)
);
const consList = computed(() =>
  normalizeListItems(analysisData.value?.cons ?? externalData.value?.cons)
);
const recommendationsList = computed(() =>
  normalizeListItems(
    analysisData.value?.recommendations ?? externalData.value?.recommendations
  )
);

const router = useRouter();
const route = useRoute();

const isMualaComputed = computed({
  get: () => dane.value.ismuala === true,
  set: (newValue) => {
    dane.value.ismuala = newValue;
  },
});

const isGroupComputed = computed({
  get: () => dane.value.isgroup === 1,
  set: (newValue) => {
    dane.value.isgroup = newValue ? 1 : 0;
  },
});

const isPremiumComputed = computed({
  get: () => dane.value.ispremium === true || dane.value.ispremium === 1,
  set: (newValue) => {
    dane.value.ispremium = !!newValue;
  },
});

const currentTagId = computed(() => route.params.id);

const goBack = () => {
  router.back();
};

const ogIframeKey = ref(0);
const refreshOG = () => {
  ogIframeKey.value++;
};

const ogPngUrl = computed(() => {
  // Build absolute URL to API OG PNG
  const base = process.env.VUE_APP_API_URL || ''
  const path = `/api/og/${currentTagId.value}.png`
  if (!base) return path
  return base.replace(/\/$/, '') + path
})
const ogPreviewTab = ref("inline");

const isRebuildingOG = ref(false)

const deleteOG = async () => {
  try {
    const user = auth.currentUser
    const idToken = user ? await user.getIdToken() : null
    const res = await fetch(`/admin/og/${currentTagId.value}`, { method: 'DELETE', headers: { 'Authorization': idToken ? `Bearer ${idToken}` : '' } })
    if (!res.ok) {
      const txt = await res.text()
      throw new Error(txt || 'delete failed')
    }
    refreshOG()
  } catch (e) {
    console.error('deleteOG error:', e)
    alert('Nie udało się usunąć OG. Sprawdź logi serwera.')
  }
}

const rebuildOG = async () => {
  try {
    isRebuildingOG.value = true
    const user = auth.currentUser
    const idToken = user ? await user.getIdToken() : null
    const res = await fetch(`/admin/og/${currentTagId.value}/rebuild`, { method: 'POST', headers: { 'Authorization': idToken ? `Bearer ${idToken}` : '' } })
    if (!res.ok) {
      const txt = await res.text()
      throw new Error(txt || 'rebuild failed')
    }
    // odśwież PNG (zmień query param aby pominąć cache przeglądarki)
    const ts = Date.now()
    const imgEl = document.querySelector('img[alt="OG PNG preview"]')
    if (imgEl) imgEl.src = ogPngUrl.value + `?t=${ts}`
    refreshOG()
  } catch (e) {
    console.error('rebuildOG error:', e)
    alert('Nie udało się przebudować OG. Sprawdź logi serwera.')
  } finally {
    // zdejmij pulsowanie po krótkiej chwili by obraz mógł się przeładować
    setTimeout(() => { isRebuildingOG.value = false }, 1200)
  }
}

const dane = ref({
  id: "",
  title: "",
  city: "",
  author: "",
  videoid: "",
  publishedat: "",
  timestamp: "",
  type: "",
  haslandingpage: 0,
  ismuala: false,
  isgroup: 0,
  ispremium: false,
  metaDescription: "",
  metaTitle: "",
  gid: "",
  cid: "",
  url_pyszne: "",
  ratingValue: "",
  reviewCount: "",
  photos: [],
});

const isUploadingPlacePhoto = ref(false);
const removingPlacePhotoUrl = ref("");
const isSavingPlacePhotosOrder = ref(false);
const draggingPlacePhotoIndex = ref(null);
const dragOverPlacePhotoIndex = ref(null);

const article = ref({
  id: "",
  json: "",
  placeId: "",
  type: "location",
  editDate: "",
  city: "",
  videoid: "",
});

const metaDane = ref({
  metaDescription: "N/A",
  metaTitle: "N/A",
  metaKeywords: "N/A",
});

watch(
  article,
  (newValue, oldValue) => {
    if (article.value && article.value.json) {
      try {
        const jsonData = JSON.parse(article.value.json);
        console.log("jsonData", jsonData);

        metaDane.value.metaTitle = `${jsonData.html.title}`;
        metaDane.value.metaDescription = `${jsonData.html.description}`;
      } catch (e) {
        // silent
      }
    }
  },
  { deep: true }
);

watch(
  () => dane.value.cid,
  (newCid) => {
    if (newCid) {
      try {
        dane.value.google_place_id = "0x" + BigInt(newCid).toString(16);
      } catch (e) {
        console.error("Could not convert CID to hex:", e);
        dane.value.google_place_id = "Invalid CID";
      }
    } else {
      dane.value.google_place_id = "";
    }
  },
  { immediate: true }
);

watch(
  placeDetails,
  (newValue, oldValue) => {
    if (placeDetails.value?.place_id) {
      dane.value.gid = placeDetails.value.place_id;
    }
  },
  { deep: true }
);

const tagsIds = ref([]);
const generatingMetaDesc = ref(false);
const influencers = ref([]);
const tags = ref([]);
const filteredTags = ref([]);
const showTagSuggestions = ref(false);
const tagInput = ref("");
const highlightedTagIndex = ref(-1);
const selectedTags = ref([]);
const quickTags = ["kebab", "polska", "pizza", "burger"];

const normalizePlacePhotos = (rawPhotos) => {
  if (!rawPhotos) return [];
  if (Array.isArray(rawPhotos)) {
    return rawPhotos
      .map((item) => (typeof item === "string" ? item.trim() : ""))
      .filter(Boolean);
  }

  if (typeof rawPhotos === "string") {
    try {
      const parsed = JSON.parse(rawPhotos);
      return normalizePlacePhotos(parsed);
    } catch (error) {
      return rawPhotos.trim() ? [rawPhotos.trim()] : [];
    }
  }

  return [];
};

const setPlacePhotos = (rawPhotos) => {
  dane.value.photos = normalizePlacePhotos(rawPhotos);
};

const placePhotos = computed(() => normalizePlacePhotos(dane.value.photos));

const toAbsoluteUploadUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return apiUrl(trimmed.startsWith("/") ? trimmed : `/${trimmed}`);
};

const triggerPlacePhotoInput = () => {
  const input = document.getElementById("place-photo-input");
  if (input) input.click();
};

const uploadSinglePlacePhoto = async (file) => {
  const form = new FormData();
  form.append("photo", file);

  const response = await apiFetch(`/api/places/${dane.value.id}/photo`, {
    method: "POST",
    body: form,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || payload?.message || "Upload failed");
  }

  if (payload?.data?.photos) {
    setPlacePhotos(payload.data.photos);
  } else if (payload?.path) {
    setPlacePhotos([...placePhotos.value, payload.path]);
  }
};

const onPlacePhotoPick = async (event) => {
  const files = Array.from(event?.target?.files || []);
  if (!files.length || !dane.value.id) return;

  isUploadingPlacePhoto.value = true;
  const failedUploads = [];
  try {
    for (const file of files) {
      try {
        await uploadSinglePlacePhoto(file);
      } catch (error) {
        failedUploads.push(`${file.name}: ${error.message}`);
      }
    }
    if (failedUploads.length) {
      alert(
        `Nie udało się wrzucić ${failedUploads.length} z ${files.length} plików:\n` +
          failedUploads.join("\n")
      );
    }
  } catch (error) {
    console.error("Place photo upload error:", error);
    alert(`Błąd podczas uploadu zdjęcia: ${error.message}`);
  } finally {
    isUploadingPlacePhoto.value = false;
    if (event?.target) event.target.value = "";
  }
};

const removePlacePhoto = async (photoUrl) => {
  if (!dane.value.id || !photoUrl) return;
  removingPlacePhotoUrl.value = photoUrl;
  try {
    const response = await apiFetch(`/api/places/${dane.value.id}/photo`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ photo: photoUrl }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload?.error || payload?.message || "Delete failed");
    }

    setPlacePhotos(payload?.data?.photos || []);
  } catch (error) {
    console.error("Place photo delete error:", error);
    alert(`Błąd podczas usuwania zdjęcia: ${error.message}`);
  } finally {
    removingPlacePhotoUrl.value = "";
  }
};

const savePlacePhotosOrder = async (orderedPhotos, { silent = false } = {}) => {
  if (!dane.value.id) return false;

  isSavingPlacePhotosOrder.value = true;
  try {
    const response = await apiFetch(`/api/places/${dane.value.id}/photos-order`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ photos: orderedPhotos }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload?.error || payload?.message || "Save order failed");
    }

    setPlacePhotos(payload?.data?.photos || orderedPhotos);
    return true;
  } catch (error) {
    console.error("Place photos order save error:", error);
    if (!silent) {
      alert(`Błąd podczas zapisu kolejności zdjęć: ${error.message}`);
    }
    return false;
  } finally {
    isSavingPlacePhotosOrder.value = false;
  }
};

const reorderPlacePhotos = async (photoIndex, targetIndex) => {
  const currentPhotos = [...placePhotos.value];

  if (photoIndex < 0 || photoIndex >= currentPhotos.length) return;
  if (targetIndex < 0 || targetIndex >= currentPhotos.length) return;
  if (photoIndex === targetIndex) return;

  const nextPhotos = [...currentPhotos];
  const [moved] = nextPhotos.splice(photoIndex, 1);
  nextPhotos.splice(targetIndex, 0, moved);
  setPlacePhotos(nextPhotos);

  const saved = await savePlacePhotosOrder(nextPhotos, { silent: true });
  if (!saved) {
    setPlacePhotos(currentPhotos);
    alert("Nie udało się zapisać nowej kolejności zdjęć.");
  }
};

const onPlacePhotoDragStart = (photoIndex, event) => {
  if (isSavingPlacePhotosOrder.value) return;
  draggingPlacePhotoIndex.value = photoIndex;
  dragOverPlacePhotoIndex.value = photoIndex;
  if (event?.dataTransfer) {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", String(photoIndex));
  }
};

const onPlacePhotoDragOver = (photoIndex, event) => {
  if (draggingPlacePhotoIndex.value === null) return;
  if (photoIndex === draggingPlacePhotoIndex.value) return;
  dragOverPlacePhotoIndex.value = photoIndex;
  if (event?.dataTransfer) {
    event.dataTransfer.dropEffect = "move";
  }
};

const onPlacePhotoDrop = async (photoIndex) => {
  if (draggingPlacePhotoIndex.value === null) return;
  const sourceIndex = draggingPlacePhotoIndex.value;
  draggingPlacePhotoIndex.value = null;
  dragOverPlacePhotoIndex.value = null;
  await reorderPlacePhotos(sourceIndex, photoIndex);
};

const onPlacePhotoDragEnd = () => {
  draggingPlacePhotoIndex.value = null;
  dragOverPlacePhotoIndex.value = null;
};

watch(
  selectedTags,
  () => {
    dane.value.type = convertTagsToString();
  },
  { deep: true }
);

watch(
  () => dane.value.type,
  (newValue) => {
    if (newValue) {
      selectedTags.value = convertStringToTags(newValue);
    }
  },
  { immediate: true }
);

const fetchInfluencers = async () => {
  try {
    const response = await apiFetch("/api/influencers");
    if (response.ok) {
      const data = await response.json();
      influencers.value = data.data;
    } else {
      console.error("Błąd podczas pobierania influencerów");
    }
  } catch (error) {
    console.error("Błąd:", error);
  }
};

const fetchTags = async () => {
  try {
    const response = await apiFetch("/api/tags");
    if (response.ok) {
      const data = await response.json();
      tags.value = data.data;
    } else {
      console.error("Błąd podczas pobierania tagów");
    }
  } catch (error) {
    console.error("Błąd:", error);
  }
};

const filterTags = () => {
  const input = tagInput.value.toLowerCase();
  if (!input) {
    filteredTags.value = tags.value.slice(0, 10);
    highlightedTagIndex.value = filteredTags.value.length ? 0 : -1;
    return;
  }

  filteredTags.value = tags.value
    .filter((tag) => tag.name.toLowerCase().includes(input))
    .slice(0, 10);
  highlightedTagIndex.value = filteredTags.value.length ? 0 : -1;
};

const normalizeTagName = (value) => String(value ?? "").trim().toLowerCase();

const hasSelectedTag = (tagName) =>
  selectedTags.value.some(
    (selectedTag) => normalizeTagName(selectedTag) === normalizeTagName(tagName)
  );

const findExistingTagName = (tagName) => {
  const normalizedTagName = normalizeTagName(tagName);
  if (!normalizedTagName) return null;

  const existingTag = tags.value.find(
    (tag) => normalizeTagName(tag.name) === normalizedTagName
  );
  return existingTag ? existingTag.name : null;
};

const parseTagsFromInput = (rawInput) =>
  String(rawInput ?? "")
    .split(/[,\n;]+/)
    .map((tag) => tag.trim())
    .filter((tag) => tag);

const addExistingTag = (tagName) => {
  const existingTagName = findExistingTagName(tagName);
  if (!existingTagName || hasSelectedTag(existingTagName)) return false;
  selectedTags.value.push(existingTagName);
  return true;
};

const addTagsFromRawInput = (rawInput) => {
  const parsedTags = parseTagsFromInput(rawInput);
  parsedTags.forEach((tagName) => addExistingTag(tagName));
};

const selectTag = (tagName) => {
  addExistingTag(tagName);

  tagInput.value = "";
  showTagSuggestions.value = false;
  highlightedTagIndex.value = -1;
};

const addTagFromInput = () => {
  addTagsFromRawInput(tagInput.value);
  tagInput.value = "";
  showTagSuggestions.value = false;
  highlightedTagIndex.value = -1;
};

const handleTagPaste = (event) => {
  const pastedText = event?.clipboardData?.getData("text") ?? "";
  if (!/[,\n;]/.test(pastedText)) return;

  event.preventDefault();
  addTagsFromRawInput(pastedText);
  tagInput.value = "";
  showTagSuggestions.value = false;
  highlightedTagIndex.value = -1;
};

const sanitizeShortDesc = (review) => {
  if (!review || typeof review.shortdesc !== "string") return;
  review.shortdesc = review.shortdesc.replace(/^\s*title:\s*/i, "");
};

const removeTag = (index) => {
  selectedTags.value.splice(index, 1);
};

const convertTagsToString = () => {
  return JSON.stringify(selectedTags.value);
};

const convertStringToTags = (tagString) => {
  if (!tagString) return [];
  try {
    return JSON.parse(tagString);
  } catch (e) {
    return tagString
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t);
  }
};

const hideTagSuggestions = () => {
  setTimeout(() => {
    showTagSuggestions.value = false;
    highlightedTagIndex.value = -1;
  }, 200);
};

const handleTagInputFocus = () => {
  showTagSuggestions.value = true;
  if (!filteredTags.value.length) {
    filterTags();
  } else if (highlightedTagIndex.value < 0) {
    highlightedTagIndex.value = 0;
  }
};

const moveTagSelectionDown = () => {
  if (!showTagSuggestions.value) {
    handleTagInputFocus();
    return;
  }
  if (!filteredTags.value.length) return;

  highlightedTagIndex.value =
    highlightedTagIndex.value < filteredTags.value.length - 1
      ? highlightedTagIndex.value + 1
      : 0;
};

const moveTagSelectionUp = () => {
  if (!showTagSuggestions.value) {
    handleTagInputFocus();
    return;
  }
  if (!filteredTags.value.length) return;

  highlightedTagIndex.value =
    highlightedTagIndex.value > 0
      ? highlightedTagIndex.value - 1
      : filteredTags.value.length - 1;
};

const handleTagEnter = () => {
  if (
    showTagSuggestions.value &&
    highlightedTagIndex.value >= 0 &&
    highlightedTagIndex.value < filteredTags.value.length
  ) {
    selectTag(filteredTags.value[highlightedTagIndex.value].name);
    return;
  }
  addTagFromInput();
};

const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

const setDefaultPublishedAt = () => {
  if (!dane.value.publishedat) {
    dane.value.publishedat = getTodayDate();
  }
};

const openGoogle = (dane) => {
  window.open(
    `https://www.google.com/search?q=pyszne.pl ${dane.title} ${dane.street} ${dane.city}`,
    "_blank"
  );
};

function removeUrlParameters(url) {
  if (!url) return "";
  try {
    const parsedUrl = new URL(url);
    return `${parsedUrl.origin}${parsedUrl.pathname}`;
  } catch (e) {
    return url;
  }
}

watch(
  () => dane.value.url_pyszne,
  (newVal) => {
    dane.value.url_pyszne = removeUrlParameters(newVal);
  }
);

const saveTag = async () => {
  try {
    const allAuthors = new Set();
    if (dane.value.author) {
      allAuthors.add(dane.value.author);
    }
    if (reviews.value && reviews.value.length > 0) {
      reviews.value.forEach(review => {
        if (review.author) {
          allAuthors.add(review.author);
        }
      });
    }

    const authorsArray = Array.from(allAuthors);

    console.log("saveTag dane.value", dane.value);
    console.log(JSON.stringify(dane.value));

    const daneDoWyslania = {
      title: dane.value.title,
      street: dane.value.street,
      postcode: dane.value.postcode,
      city: dane.value.city,
      lat: dane.value.lat,
      lng: dane.value.lng,
      author: JSON.stringify(authorsArray),
      videoid: dane.value.videoid,
      publishedat: dane.value.publishedat,
      timestamp: dane.value.timestamp || null,
      type: convertTagsToString(),
      haslandingpage: !!(article.value && article.value.json),
      ismuala: dane.value.ismuala,
      isgroup: !!dane.value.isgroup,
      ispremium: !!dane.value.ispremium,
      gid: dane.value.gid,
      cid: dane.value.cid,
      url_pyszne: dane.value.url_pyszne,
      ratingvalue: dane.value.ratingValue,
      reviewcount: dane.value.reviewCount,
      status: dane.value.status,
    };

    console.log("daneDoWyslania:", daneDoWyslania);

    const response = await apiFetch(
      `/api/dane/${route.params.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(daneDoWyslania),
      }
    );
    if (response.ok) {
      console.log("SAVED!");
    } else {
      const errorText = await response.text();
      console.error("Server error response:", errorText);
      console.error("Response status:", response.status);
      console.error("Response headers:", response.headers);
      throw new Error(
        `Problem z zapisem danych: ${response.status} - ${errorText}`
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const saveReview = async (review) => {
  try {
    console.log("saveReview (review)", review);
    const id = review.id;

    const reviewData = {
      placeid: review.placeid || review.placeId,
      shortdesc: review.shortdesc || "",
      text: review.text || "",
      author: review.author || "ksiazulo",
      videoid: review.videoid || "",
      timestamp:
        review.timestamp && review.timestamp !== ""
          ? parseInt(review.timestamp)
          : null,
      publishedat:
        review.publishedat || new Date().toISOString().split("T")[0],
    };

    console.log("Sending review data:", reviewData);
    console.log("Review data JSON:", JSON.stringify(reviewData));

    const response = await apiFetch(
      `/api/review/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reviewData),
      }
    );
    if (response.ok) {
      console.log("Review SAVED!");
    } else {
      const errorText = await response.text();
      console.error("Server error response:", errorText);
      console.error("Response status:", response.status);
      console.error("Response headers:", response.headers);
      throw new Error(
        `Problem z zapisem danych: ${response.status} - ${errorText}`
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const saveAllReviews = async (reviews) => {
  try {
    for (const review of reviews) {
      await saveReview(review);
    }
  } catch (error) {
    console.error(error);
  }
};

const saveArticle = async () => {
  try {
    if (!article.value.json || article.value.json.trim() === "") {
      console.log("Article JSON is empty, skipping save");
      return;
    }

    let rawJson = JSON.parse(article.value.json);

    rawJson.html.title = metaDane.value.metaTitle;
    rawJson.html.description = metaDane.value.metaDescription;

    article.value.videoid = rawJson.body.videoId;

    article.value.json = JSON.stringify(rawJson);
    article.value.id = route.params.id;
    article.value.placeId = route.params.id;
    article.value.type = "location";
    article.value.city = dane.value.city;

    const daneDoWyslania = {
      ...article.value,
    };

    console.log("daneDoWyslania przed wysłaniem:", daneDoWyslania);

    const response = await apiFetch(`/api/article`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(daneDoWyslania),
    });

    if (response.ok) {
      console.log("SAVED ARTICLE!");
    } else {
      const errorText = await response.text();
      console.error("Server error response:", errorText);
      console.error("Response status:", response.status);
      console.error("Response headers:", response.headers);
      throw new Error(
        `Problem z zapisem danych: ${response.status} - ${errorText}`
      );
    }
  } catch (error) {
    console.error("Error in saveArticle:", error.message);
    if (error.message.includes("Unexpected end of JSON input")) {
      console.error(
        "JSON parsing error - article.value.json might be empty or invalid"
      );
      console.error("article.value.json:", article.value.json);
    }
  }
};

const saveAll = async (gid) => {
  try {
    await saveTag();
    await saveArticle();
    await saveAllReviews(reviews.value);
  } catch (error) {
    console.error(error);
  }
};

const showNextTag = (tagId) => {
  router.push({ name: "tag", params: { id: tagId } });
  placeDetails.value = null;
  placeDetailsFull.value = null;
};

const fetchAllData = async () => {
  try {
    const response = await apiFetch("/api/places/all");
    if (response.ok) {
      const data = await response.json();
      tagsIds.value = data.data.map((object) => object.id);
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchSpecificData = async (id) => {
  try {
    const response = await apiFetch(`/api/dane/${id}`);
    if (response.ok) {
      const data = await response.json();
      console.log("fetchSpecificData:", data.data);
      dane.value = data.data;
      setPlacePhotos(data?.data?.photos);
      console.log(dane.value);
      if (dane.value.type) {
        selectedTags.value = convertStringToTags(dane.value.type);
      }
      setDefaultPublishedAt();
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchArticleData = async (id) => {
  try {
    const response = await apiFetch(`/api/article/${id}`);
    if (response.ok) {
      const data = await response.json();
      article.value = data.data;
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchReviews = async (id) => {
  try {
    const response = await apiFetch(`/api/reviews/${id}`);
    if (response.ok) {
      const data = await response.json();
      console.log("fetchReviews:", data.data);
      reviews.value = data.data.reverse();
      console.log(reviews.value);
    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};

const position = computed({
  get: () => `${dane.value.lat}, ${dane.value.lng}`,
  set: (newValue) => {
    const [lat, lng] = newValue.split(",").map(Number);
    dane.value.lat = lat;
    dane.value.lng = lng;
  },
});

onMounted(async () => {
  const id = route.params.id;

  try {
    await fetchAllData();
    await fetchSpecificData(id);
    // await fetchArticleData(id);
    await fetchReviews(id);
    await fetchInfluencers();
    await fetchTags();
  } catch (error) {
    console.error(error);
  }
});

watch(
  () => dane.value.haslandingpage,
  (haslandingpage, oldHaslandingpage) => {
    if (haslandingpage) {
      fetchArticleData(route.params.id);
    }
  },
  { immediate: true }
);

watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      yesMaybeData.value = null;
      yesMaybeError.value = "";
      ogPreviewTab.value = "inline";
      refreshOG();
      article.value.json = "";
      fetchSpecificData(newId);
      if (dane.value.haslandingpage) {
        fetchArticleData(newId);
      }
      fetchReviews(newId);
    }
  }
  // { immediate: true }
);

function removeQuotes(tekst) {
  if (tekst.startsWith('"') && tekst.endsWith('"')) {
    return tekst.slice(1, -1);
  }
  return tekst;
}

async function copyToClipboard(wartosc) {
  try {
    await navigator.clipboard.writeText(wartosc);
    console.log("Tekst skopiowany do schowka");
  } catch (err) {
    console.error("Błąd podczas kopiowania do schowka: ", err);
  }
}

function changeToUrlTypeString(str) {
  return str.toLowerCase().replace(/\s+/g, "-");
}

let exceptions = ["to", "for", "with"];

function titleCase(str, exceptions) {
  return str
    .split(" ")
    .map((word, index) => {
      if (index === 0 || !exceptions.includes(word.toLowerCase())) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join(" ");
}

function countCharactersWithEmojis(text = "") {
  const splitText = Array.from(text);
  return splitText.length;
}

const putSearchToMaps = () => {
  const input = document.getElementById("pac-input");
  if (input) {
    input.value = `${dane.value.title} ${dane.value.street}`;
    input.focus();
  }
};

const fetchYesMaybePlaceDetails = async (cid, { silent = true } = {}) => {
  if (!cid || isAnalyzingYesMaybe.value || isAutoLoadingYesMaybe.value) {
    return;
  }

  isAutoLoadingYesMaybe.value = true;
  if (!silent) {
    yesMaybeError.value = "";
  }

  try {
    const user = auth.currentUser;
    const idToken = user ? await user.getIdToken() : null;
    const headers = {};
    if (idToken) {
      headers.Authorization = `Bearer ${idToken}`;
    }

    const res = await fetch(`/admin/place-details/${encodeURIComponent(cid)}`, {
      method: "GET",
      headers,
    });

    if (!res.ok) {
      const errBody = await res.text();
      console.warn("[YesMaybe:auto-load] upstream error", {
        cid,
        status: res.status,
        errBody,
      });
      if (!silent) {
        yesMaybeError.value = `Nie udalo sie pobrac danych YesMaybe (${res.status}).`;
      }
      return;
    }

    const data = await res.json();
    if (data && typeof data === "object" && Object.keys(data).length > 0) {
      yesMaybeData.value = data;
      console.info("[YesMaybe:auto-load] loaded", { cid, keys: Object.keys(data) });
    }
  } catch (error) {
    console.error("[YesMaybe:auto-load] failed", { cid, error });
    if (!silent) {
      yesMaybeError.value = "Blad podczas automatycznego pobierania danych YesMaybe.";
    }
  } finally {
    isAutoLoadingYesMaybe.value = false;
  }
};

const analyzeYesMaybe = async () => {
  if (!dane.value.gid) {
    yesMaybeError.value = "Brak place_id (gid) dla aktualnego itemu.";
    return;
  }

  isAnalyzingYesMaybe.value = true;
  yesMaybeError.value = "";
  yesMaybeData.value = null;

  try {
    const traceId = `yesmaybe-${Date.now()}`;
    const user = auth.currentUser;
    const idToken = user ? await user.getIdToken() : null;
    const headers = {
      "Content-Type": "application/json",
      "X-Debug-Trace-Id": traceId,
    };

    if (idToken) {
      headers.Authorization = `Bearer ${idToken}`;
    }

    console.info("[YesMaybe:start]", {
      traceId,
      place_id: dane.value.gid,
      hasToken: Boolean(idToken),
    });
    const res = await fetch(
      "/admin/analyze-place-id",
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          place_id: dane.value.gid,
          limit: 50,
        }),
      }
    );

    console.info("[YesMaybe:response]", {
      traceId,
      status: res.status,
      ok: res.ok,
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.warn("[YesMaybe:error-body]", { traceId, errorText });
      let parsedMessage = errorText;
      try {
        const parsed = JSON.parse(errorText);
        if (parsed?.error === "missing-external-api-key") {
          parsedMessage =
            "Brak EXTERNAL_API_KEY na backendzie (lub ANALYZE_PLACE_API_KEY).";
        } else if (parsed?.message === "no available server") {
          parsedMessage =
            "Usluga YesMaybe jest chwilowo niedostepna (503 no available server). Sprobuj ponownie za chwile.";
        }
      } catch (e) {
        // keep raw error text
      }
      throw new Error(parsedMessage || "Nie udało się pobrać danych YesMaybe.");
    }

    const data = await res.json();
    yesMaybeData.value = data;
    console.log("YesMaybe analyze result:", {
      traceId,
      keys: data && typeof data === "object" ? Object.keys(data) : [],
      data,
    });
  } catch (error) {
    console.error("YesMaybe analyze error:", error);
    yesMaybeError.value = error?.message || "Błąd podczas pobierania danych.";
  } finally {
    isAnalyzingYesMaybe.value = false;
  }
};

const map = ref(null);
const mapElement = ref(null);
const infowindowRef = ref(null);
const initialPosition = { lat: 52.22977, lng: 21.01178 };

onMounted(() => {
  loadGoogleMapsScript().then(() => {
    initMap();
  });
});

watch(
  () => dane.value.cid,
  async (newCid) => {
    if (!newCid) return;
    if (yesMaybeData.value) return;
    await fetchYesMaybePlaceDetails(newCid, { silent: true });
  }
);

watch(
  yesMaybeData,
  (newData) => {
    if (!newData) return;
    syncRatingFromYesMaybe(newData);
  },
  { deep: true }
);

function initMap() {
  map.value = new google.maps.Map(document.getElementById("map"), {
    center: { lat: initialPosition.lat, lng: initialPosition.lng },
    zoom: 13,
  });
  const input = document.getElementById("pac-input");
  const autocomplete = new google.maps.places.Autocomplete(input, {
    fields: ["place_id", "geometry", "formatted_address", "name"],
  });

  autocomplete.bindTo("bounds", map.value);
  map.value.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

  const infowindow = new google.maps.InfoWindow();
  infowindowRef.value = infowindow;

  const infowindowContent = document.getElementById("infowindow-content");
  infowindow.setContent(infowindowContent);

  const marker = new google.maps.Marker({ map: map.value });

  marker.addListener("click", () => {
    infowindow.open(map.value, marker);
  });
  autocomplete.addListener("place_changed", () => {
    infowindow.close();

    const place = autocomplete.getPlace();

    if (!place.geometry || !place.geometry.location) {
      return;
    }

    if (place.geometry.viewport) {
      map.value.fitBounds(place.geometry.viewport);
    } else {
      map.value.setCenter(place.geometry.location);
      map.value.setZoom(14);
    }

    marker.setPlace({
      placeId: place.place_id,
      location: place.geometry.location,
    });
    marker.setVisible(true);
    infowindowContent.children.namedItem("place-name").textContent =
      place.name;
    infowindowContent.children.namedItem("place-id").textContent =
      place.place_id;
    infowindowContent.children.namedItem("place-address").textContent =
      place.formatted_address;
    infowindowContent.children.namedItem("place-lat").textContent =
      place.geometry.location.lat();
    infowindowContent.children.namedItem("place-lng").textContent =
      place.geometry.location.lng();

    infowindow.open(map.value, marker);

    console.log("place: ", place);
    placeDetails.value = place;
    placeDetails.value.position = `${place.geometry.location.lat()}, ${place.geometry.location.lng()}`;
  });
}

function loadGoogleMapsScript() {
  return new Promise((resolve) => {
    if (typeof google !== "undefined" && google.maps) {
      resolve();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCiNeI2j5GhrMCeyJcEtCmPxJdejQXr7r0&callback=initMap`;
      script.async = true;
      document.head.appendChild(script);
      window.initMap = () => {
        resolve();
      };
    }
  });
}

const getPlaceDetails = async (placeId) => {
  const normalizedPlaceId = String(placeId || "").trim();
  if (!normalizedPlaceId) {
    console.warn(`${CID_DEBUG_PREFIX} getPlaceDetails aborted (missing placeId)`);
    return;
  }

  if (
    typeof google === "undefined" ||
    !google.maps ||
    !google.maps.places ||
    !map.value
  ) {
    console.error(`${CID_DEBUG_PREFIX} getPlaceDetails aborted (Google Maps not ready)`, {
      placeId: normalizedPlaceId,
      hasGoogle: typeof google !== "undefined",
      hasMapInstance: Boolean(map.value),
    });
    return;
  }

  logCidDebug("getPlaceDetails requested", {
    placeId: normalizedPlaceId,
    existingCid: normalizeCid(dane.value.cid) || null,
  });

  const service = new google.maps.places.PlacesService(map.value);
  const primaryFields = [
    "name",
    "rating",
    "formatted_phone_number",
    "geometry",
    "business_status",
    "address_components",
    "formatted_address",
    "plus_code",
    "icon",
    "opening_hours",
    "photos",
    "place_id",
    "reviews",
    "types",
    "url",
    "vicinity",
    "website",
    "price_level",
    "international_phone_number",
    "adr_address",
    "user_ratings_total",
    "utc_offset_minutes",
    "serves_beer",
    "serves_breakfast",
    "serves_brunch",
    "serves_dinner",
    "serves_lunch",
    "serves_vegetarian_food",
    "serves_wine",
    "takeout",
    "editorial_summary",
    "dine_in",
    "delivery",
  ];
  const fallbackFields = [
    "place_id",
    "url",
    "name",
    "formatted_address",
    "address_components",
    "geometry",
    "rating",
    "user_ratings_total",
    "formatted_phone_number",
    "international_phone_number",
    "website",
    "opening_hours",
    "reviews",
    "types",
    "price_level",
    "business_status",
    "vicinity",
    "adr_address",
    "plus_code",
    "photos",
  ];

  const requestDetails = (fields, label) =>
    new Promise((resolve) => {
      logCidDebug("getPlaceDetails request", {
        placeId: normalizedPlaceId,
        label,
        fieldCount: fields.length,
        fields,
      });
      service.getDetails(
        {
          placeId: normalizedPlaceId,
          fields,
        },
        (place, status) => resolve({ place, status, label, fields })
      );
    });

  let result = await requestDetails(primaryFields, "primary");
  logCidDebug("getPlaceDetails response", {
    placeId: normalizedPlaceId,
    label: result.label,
    status: result.status,
    hasUrl: Boolean(result.place?.url),
    returnedPlaceId: result.place?.place_id || null,
  });

  if (
    result.status === google.maps.places.PlacesServiceStatus.INVALID_REQUEST
  ) {
    console.warn(`${CID_DEBUG_PREFIX} Primary getDetails request was rejected, retrying with fallback fields`, {
      placeId: normalizedPlaceId,
    });
    result = await requestDetails(fallbackFields, "fallback");
    logCidDebug("getPlaceDetails response", {
      placeId: normalizedPlaceId,
      label: result.label,
      status: result.status,
      hasUrl: Boolean(result.place?.url),
      returnedPlaceId: result.place?.place_id || null,
    });
  }

  if (result.status === google.maps.places.PlacesServiceStatus.OK) {
    placeDetailsFull.value = result.place;
    console.log("placeDetailsFull.value: ", placeDetailsFull.value);
    await syncCidFromPlaceDetails(result.place, "getPlaceDetails");
  } else {
    console.error("Place details request failed due to ", result.status);
  }
};

watch(placeDetailsFull, (newVal) => {
  if (placeDetailsFull.value) {
    dane.value.ratingValue = placeDetailsFull.value.rating;
    dane.value.reviewCount = placeDetailsFull.value.user_ratings_total;
  } else {
    dane.value.ratingValue = "";
    dane.value.reviewCount = "";
  }
});

watch(
  reviews,
  (newVal) => {
    console.log("Nowa wartość reviews:", newVal);
  },
  { deep: true }
);

const openUrl = (url) => {
  window.open(url, "_blank");
};

const CID_DEBUG_PREFIX = "[CID DEBUG]";

const logCidDebug = (message, payload) => {
  if (payload === undefined) {
    console.info(`${CID_DEBUG_PREFIX} ${message}`);
    return;
  }
  console.info(`${CID_DEBUG_PREFIX} ${message}`, payload);
};

const normalizeCid = (rawCid) => {
  if (rawCid === null || rawCid === undefined) return "";
  const cidCandidate = String(rawCid).trim();
  if (!cidCandidate) return "";
  if (!/^-?\d+$/.test(cidCandidate)) return "";

  // Some integrations return signed int64 CID. Convert to unsigned decimal.
  if (cidCandidate.startsWith("-")) {
    try {
      return BigInt.asUintN(64, BigInt(cidCandidate)).toString();
    } catch (error) {
      console.warn(`${CID_DEBUG_PREFIX} Could not normalize signed CID`, {
        cidCandidate,
        error,
      });
      return "";
    }
  }

  return cidCandidate;
};

const applyCidToForm = (cidValue, source) => {
  const normalizedCid = normalizeCid(cidValue);
  if (!normalizedCid) return false;

  const previousCid = normalizeCid(dane.value.cid);
  dane.value.cid = normalizedCid;

  logCidDebug("CID synchronized", {
    source,
    previousCid: previousCid || null,
    nextCid: normalizedCid,
  });
  return true;
};

const extractCidFromGoogleUrl = (rawUrl, source = "unknown") => {
  if (!rawUrl || typeof rawUrl !== "string") {
    logCidDebug("extractCidFromGoogleUrl skipped (empty url)", { source });
    return "";
  }

  const urlValue = rawUrl.trim();
  try {
    const parsed = new URL(urlValue);
    const cidFromQuery = normalizeCid(parsed.searchParams.get("cid"));
    if (cidFromQuery) {
      logCidDebug("CID extracted from URL query", {
        source,
        cid: cidFromQuery,
      });
      return cidFromQuery;
    }
  } catch (error) {
    logCidDebug("URL parsing failed, using regex fallback", {
      source,
      urlValue,
      error: error?.message || String(error),
    });
  }

  const plainMatch = urlValue.match(/(?:[?&]cid=)(-?\d{5,})/i);
  if (plainMatch?.[1]) {
    const normalized = normalizeCid(plainMatch[1]);
    if (normalized) {
      logCidDebug("CID extracted from plain regex", {
        source,
        cid: normalized,
      });
      return normalized;
    }
  }

  let decodedUrl = urlValue;
  try {
    decodedUrl = decodeURIComponent(urlValue);
  } catch (error) {
    // Keep original value when decode fails.
  }

  const decodedMatch = decodedUrl.match(/(?:[?&]cid=)(-?\d{5,})/i);
  if (decodedMatch?.[1]) {
    const normalized = normalizeCid(decodedMatch[1]);
    if (normalized) {
      logCidDebug("CID extracted from decoded regex", {
        source,
        cid: normalized,
      });
      return normalized;
    }
  }

  logCidDebug("CID not found in URL", {
    source,
    urlValue,
  });
  return "";
};

const fetchCidByPlaceId = async (placeId) => {
  const normalizedPlaceId = String(placeId || "").trim();
  if (!normalizedPlaceId) {
    logCidDebug("Fallback CID fetch skipped (missing placeId)");
    return "";
  }

  if (
    typeof google === "undefined" ||
    !google.maps ||
    !google.maps.places ||
    !map.value
  ) {
    console.warn(`${CID_DEBUG_PREFIX} Fallback CID fetch skipped (Google Maps not ready)`, {
      placeId: normalizedPlaceId,
      hasGoogle: typeof google !== "undefined",
      hasMapInstance: Boolean(map.value),
    });
    return "";
  }

  return await new Promise((resolve) => {
    const fallbackService = new google.maps.places.PlacesService(map.value);
    fallbackService.getDetails(
      { placeId: normalizedPlaceId, fields: ["place_id", "url"] },
      (place, status) => {
        logCidDebug("Fallback getDetails response", {
          placeId: normalizedPlaceId,
          status,
          hasUrl: Boolean(place?.url),
        });

        if (status !== google.maps.places.PlacesServiceStatus.OK) {
          resolve("");
          return;
        }

        const fallbackUrl = place?.url || "";
        const fallbackCid = extractCidFromGoogleUrl(
          fallbackUrl,
          "fallback:places-service"
        );
        resolve(fallbackCid);
      }
    );
  });
};

const syncCidFromPlaceDetails = async (placeDetails, source = "unknown") => {
  if (!placeDetails) {
    logCidDebug("CID sync skipped (missing placeDetails)", { source });
    return;
  }

  const placeId = String(placeDetails.place_id || "").trim();
  const placeUrl = placeDetails.url || "";

  logCidDebug("Starting CID sync", {
    source,
    placeId: placeId || null,
    hasUrl: Boolean(placeUrl),
    currentCid: normalizeCid(dane.value.cid) || null,
  });

  const cidFromUrl = extractCidFromGoogleUrl(placeUrl, `${source}:primary-url`);
  if (applyCidToForm(cidFromUrl, `${source}:primary-url`)) {
    return;
  }

  const fallbackCid = await fetchCidByPlaceId(placeId);
  if (applyCidToForm(fallbackCid, `${source}:fallback`)) {
    return;
  }

  console.warn(`${CID_DEBUG_PREFIX} CID sync failed`, {
    source,
    placeId: placeId || null,
    placeUrl: placeUrl || null,
  });
};

watch(
  placeDetailsFull,
  (newValue) => {
    if (!newValue) return;
    if (newValue.url) {
      logCidDebug("placeDetailsFull updated with URL", {
        placeId: newValue.place_id || null,
        url: newValue.url,
      });
    } else {
      logCidDebug("placeDetailsFull updated without URL", {
        placeId: newValue.place_id || null,
      });
    }
  },
  { deep: false }
);

const addReview = async (review) => {
  try {
    const reviewData = {
      placeid: review.placeId,
      shortdesc: review.shortdesc || "",
      text: review.text || "",
      author: review.author || "ksiazulo",
      videoid: review.videoid || "",
      timestamp:
        review.timestamp && review.timestamp !== ""
          ? parseInt(review.timestamp)
          : null,
      publishedat: review.publishedat || new Date().toISOString().split("T")[0],
    };

    console.log("Sending review data:", reviewData);

    const response = await apiFetch(
      `/api/review/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reviewData),
      }
    );
    if (response.ok) {
      console.log("REVIEW SAVED!");
    } else {
      const errorText = await response.text();
      console.error("Server error response:", errorText);
      console.error("Response status:", response.status);
      console.error("Response headers:", response.headers);
      throw new Error(
        `Problem z zapisem danych: ${response.status} - ${errorText}`
      );
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const addNewReview = async (placeId) => {
  console.log("addNewReview");
  console.log("placeId", placeId);

  const review = {
    placeId: placeId,
    shortdesc: "",
    text: "",
    author: "",
    videoid: "",
    timestamp: null,
    publishedat: getTodayDate(),
  };

  console.log("Review:", review);
  console.log(`Added review placeId: ${review.placeId}`);
  await addReview(review);
  await fetchReviews(placeId);
};

const addReviewAll = async () => {
  try {
    const data = await fetchAllData();

    let count = 0;
    for (const item of data) {
      const review = {
        placeId: item.id,
        shortdesc: item.shortDesc,
        text: item.opis,
        author: item.author,
        videoid: item.videoid,
        timestamp:
          item.timestamp && item.timestamp !== ""
            ? parseInt(item.timestamp)
            : null,
        publishedat: item.publishedat,
      };

      console.log(`${count}\treview placeId: ${review.placeId}`);
      await addReview(review);
      count++;
    }
  } catch (error) {
    console.error(error);
  }
};

watch(reviews, () => {
  if (!reviews.value) return;

  reviews.value.forEach((review) => {
    watch(
      () => review.videoid,
      (newValue) => {
        if (!newValue) return;
        if (
          !newValue.includes("youtube.com") &&
          !newValue.includes("youtu.be")
        )
          return;

        const extractVideoInfo = (url) => {
          let videoid = "";
          let timestamp = "";

          const fullUrlMatch = url.match(/[?&]v=([^&]+)/);
          if (fullUrlMatch) videoid = fullUrlMatch[1];

          const shortUrlMatch = url.match(/youtu\.be\/([^?]+)/);
          if (shortUrlMatch) videoid = shortUrlMatch[1];

          const timeMatch = url.match(/[?&]t=(\d+)/);
          if (timeMatch) timestamp = timeMatch[1];

          return { videoid, timestamp };
        };

        const { videoid: extractedVideoid, timestamp } =
          extractVideoInfo(newValue);

        if (extractedVideoid && extractedVideoid !== review.videoid) {
          review.videoid = extractedVideoid;
          if (timestamp) {
            review.timestamp = timestamp;
          }
        }
      },
      { immediate: true }
    );

    if (!review.author) {
      review.author = "ksiazulo";
    }

    if (!review.publishedat) {
      review.publishedat = getTodayDate();
    }
  });
}, { deep: true });

const pasteReview = async (dane) => {
  try {
    const text = await showPasteModal();

    if (!text) {
      throw new Error("Nie wprowadzono tekstu JSON");
    }

    const parsedPayload = JSON.parse(text);

    const resolveReviewSource = (payload) => {
      if (!payload) return null;

      if (Array.isArray(payload)) {
        return payload.find((item) => item && typeof item === "object") || null;
      }

      if (typeof payload !== "object") return null;

      const possibleKeys = ["review", "reviews", "data", "payload"];
      for (const key of possibleKeys) {
        const value = payload[key];
        if (!value) continue;
        if (Array.isArray(value)) {
          const candidate = value.find(
            (item) => item && typeof item === "object"
          );
          if (candidate) return candidate;
        } else if (typeof value === "object") {
          return value;
        }
      }

      return payload;
    };

    const reviewSource = resolveReviewSource(parsedPayload);

    if (!reviewSource || typeof reviewSource !== "object") {
      throw new Error("Nie znaleziono danych recenzji w przekazanym JSONie");
    }

    const pickValue = (keys) => {
      for (const key of keys) {
        const value = reviewSource[key];
        if (value !== undefined && value !== null && value !== "") {
          return value;
        }
      }
      return undefined;
    };

    const convertTimestampToSeconds = (value) => {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      if (typeof value === "number" && !Number.isNaN(value)) {
        return Math.floor(value).toString();
      }

      const normalized = String(value).trim();

      if (!normalized) {
        return "";
      }

      if (/^\d+$/.test(normalized)) {
        return normalized;
      }

      const timeParts = normalized.split(":");
      if (
        timeParts.length >= 2 &&
        timeParts.every(
          (part) => part !== "" && !Number.isNaN(Number(part.trim()))
        )
      ) {
        let multiplier = 1;
        let totalSeconds = 0;

        for (let i = timeParts.length - 1; i >= 0; i -= 1) {
          const numericPart = Number(timeParts[i].trim());
          totalSeconds += numericPart * multiplier;
          multiplier *= 60;
        }

        return totalSeconds.toString();
      }

      return normalized;
    };

    const shortDesc = pickValue(["shortDesc", "shortdesc", "short_description"]);
    if (shortDesc !== undefined) {
      dane.shortdesc = shortDesc;
    }

    const fullText = pickValue(["opis", "text", "description", "review"]);
    if (fullText !== undefined) {
      dane.text = fullText;
    }

    const videoId = pickValue(["videoId", "videoid", "video_id"]);
    if (videoId !== undefined) {
      dane.videoid = videoId;
    }

    const author = pickValue(["author", "influencer", "creator"]);
    if (author !== undefined) {
      dane.author = author;
    }

    const timestampRaw = pickValue([
      "timestamp",
      "time",
      "timecode",
      "timeCode",
      "czas",
    ]);
    if (timestampRaw !== undefined) {
      const convertedTimestamp = convertTimestampToSeconds(timestampRaw);
      if (convertedTimestamp !== "") {
        dane.timestamp = convertedTimestamp;
      } else {
        dane.timestamp = "";
      }
    }

    if (!dane.author) {
      dane.author = "ksiazulo";
    }

    isError.value = false;
  } catch (error) {
    console.error("Error:", error);
    isError.value = true;

    const errorMessage = document.createElement("div");
    errorMessage.className =
      "fixed top-4 right-4 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg z-50";
    errorMessage.textContent = `Błąd: ${error.message}`;
    document.body.appendChild(errorMessage);

    setTimeout(() => {
      isError.value = false;
      if (document.body.contains(errorMessage)) {
        document.body.removeChild(errorMessage);
      }
    }, 3000);
  }
};

const showPasteModal = () => {
  return new Promise((resolve) => {
    const modal = document.createElement("div");
    modal.className =
      "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50";
    modal.innerHTML = `
      <div class="bg-gray-800 p-6 rounded-lg max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <h3 class="text-white text-lg font-semibold mb-4">Wklej JSON z recenzją</h3>
        
        <div class="mb-4 p-3 bg-gray-700 rounded-md">
          <p class="text-gray-300 text-sm mb-2">📋 Instrukcja:</p>
          <ol class="text-gray-300 text-sm list-decimal list-inside space-y-1">
            <li>Skopiuj JSON z recenzją (Ctrl+C / Cmd+C)</li>
            <li>Kliknij w pole tekstowe poniżej</li>
            <li>Wklej JSON (Ctrl+V / Cmd+V)</li>
            <li>Kliknij "Potwierdź"</li>
          </ol>
        </div>
        
        <textarea 
          id="jsonPasteArea" 
          class="w-full h-64 p-3 bg-gray-700 text-white border border-gray-600 rounded-md font-mono text-sm resize-none"
          placeholder="Wklej tutaj JSON z recenzją...&#10;Przykład:&#10;[&#10;  {&#10;    &quot;shortDesc&quot;: &quot;Opis recenzji&quot;,&#10;    &quot;opis&quot;: &quot;Pełny tekst recenzji&quot;,&#10;    &quot;videoId&quot;: &quot;ID_filmu&quot;,&#10;    &quot;timestamp&quot;: &quot;00:02:14&quot;&#10;  }&#10;]"
        ></textarea>
        
        <div class="flex justify-between items-center mt-4">
          <div class="text-gray-400 text-sm">
            💡 Wskazówka: JSON powinien być w formacie tablicy z obiektem recenzji
          </div>
          <div class="flex gap-3">
            <button 
              id="cancelPaste" 
              class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            >
              Anuluj
            </button>
            <button 
              id="confirmPaste" 
              class="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
            >
              Potwierdź
            </button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const textarea = modal.querySelector("#jsonPasteArea");
    textarea.focus();

    modal.querySelector("#cancelPaste").onclick = () => {
      document.body.removeChild(modal);
      resolve(null);
    };

    modal.querySelector("#confirmPaste").onclick = () => {
      const text = textarea.value.trim();
      if (!text) {
        alert("Proszę wkleić JSON przed potwierdzeniem");
        return;
      }
      document.body.removeChild(modal);
      resolve(text);
    };

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        document.body.removeChild(modal);
        document.removeEventListener("keydown", handleEscape);
        resolve(null);
      }
    };
    document.addEventListener("keydown", handleEscape);

    textarea.addEventListener("paste", (e) => {
      setTimeout(() => {
        textarea.focus();
      }, 100);
    });
  });
};

const confirmDeleteLocal = () => {
  const confirmed = confirm(
    `Czy na pewno chcesz usunąć lokal "${dane.value.title}"?\n\nTa operacja jest nieodwracalna i usunie wszystkie dane związane z tym lokalem.`
  );

  if (confirmed) {
    deleteLocal();
  }
};

const deleteLocal = async () => {
  try {
    console.log("Usuwanie lokalu:", dane.value.id);

    const response = await apiFetch(
      `/api/dane/${dane.value.id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      console.log("Lokal został pomyślnie usunięty!");

      const successMessage = document.createElement("div");
      successMessage.className =
        "fixed top-4 right-4 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50";
      successMessage.textContent = "Lokal został pomyślnie usunięty!";
      document.body.appendChild(successMessage);

      setTimeout(() => {
        document.body.removeChild(successMessage);
        router.push("/");
      }, 2000);
    } else {
      throw new Error("Problem z usunięciem lokalu");
    }
  } catch (error) {
    console.error("Błąd podczas usuwania lokalu:", error);

    const errorMessage = document.createElement("div");
    errorMessage.className =
      "fixed top-4 right-4 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg z-50";
    errorMessage.textContent = "Wystąpił błąd podczas usuwania lokalu";
    document.body.appendChild(errorMessage);

    setTimeout(() => {
      document.body.removeChild(errorMessage);
    }, 3000);
  }
};

const deleteReview = async (reviewId) => {
  if (!confirm('Czy na pewno chcesz usunąć tę recenzję? Tej operacji nie można cofnąć.')) {
    return;
  }

  try {
    const response = await apiFetch(`/api/review/${reviewId}`, {
      method: 'DELETE',
    });

    if (response.ok) {
      // Usuń recenzję z lokalnej listy, aby UI się odświeżył
      reviews.value = reviews.value.filter(review => review.id !== reviewId);
      console.log('Recenzja usunięta pomyślnie!');
    } else {
      const errorText = await response.text();
      console.error('Błąd podczas usuwania recenzji:', errorText);
      alert(`Nie udało się usunąć recenzji: ${errorText}`);
    }
  } catch (error) {
    console.error('Błąd:', error);
    alert('Wystąpił błąd podczas usuwania recenzji.');
  }
};
</script>

<style>
#googleUrl {
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  font-size: small;
  line-height: 1.58;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
  line-height: 1.3;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  color: #a8a8a8;
  font-style: normal;
}

#googleBreakcrumbs {
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  font-family: Roboto, arial, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  color: #a8a8a8;
  font-style: normal;
  font-size: 12px;
  line-height: 18px;
  margin-top: -5px;
}

#googleTitle {
  padding-top: 5px;
  margin-bottom: 3px;
  font-size: 20px;
  line-height: 1.3;
  color: #8ab4f8;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

#googleTitle2 {
  margin-left: -14px;
  width: 625px;
  padding-top: 5px;
  margin-bottom: 3px;
  font-size: 20px;
  line-height: 1.3;
  color: #8ab4f8;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

#googleDescription {
  max-width: 48em;
  color: #4d5156;
  line-height: 1.58;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
}

#googleDescription2 {
  width: 626px;
  height: 88px;
  color: #c9c9c9;
  line-height: 1.58;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
  margin-left: -13px;
}

.whiteGoogle {
  padding: 25px;
  width: 650px;
  margin: auto;
}

.dots {
  height: 18px;
  line-height: 18px;
  width: 18px;
  opacity: 0.6;
  padding-top: 4px;
  margin-left: 12px;
}

#googleBox span {
  display: inline-block;
}

.googleTop {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.favicon {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f3f4;
  border: 1px solid #ecedef;
  border-radius: 50%;
  height: 28px;
  width: 28px;
  margin-right: 12px;
}

.favicon > div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.favicon img {
  max-width: 18px;
  height: 18px;
  width: 18px;
}

.smallText {
  display: block;
}

.smallText > div {
  display: block;
}

.googleBreadcrumbsContainer {
  margin-top: -10px;
}

#place-name {
  font-weight: bold;
}
#place-address {
  margin-bottom: 10px;
}

.dot {
  transition: transform 0.2s;
}
input[type="checkbox"].peer:checked + span + .dot {
  transform: translateX(20px);
}

.map {
  width: 100%;
  height: 420px;
}
</style>